import { saveSalesforceWebToLead } from '@lib/api';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { sfWebToLeadAtom, sfWebToLeadSelector } from '../state';

export const useSaveSalesforceWebToLead = () => {
    const sfWebToLead = useRecoilValue(sfWebToLeadSelector);
    const setSalesforceWebToLead = useSetRecoilState(sfWebToLeadAtom);

    return async (vestimateAmt?: number, googlePlaceID?: string) => {
        if (!sfWebToLead) {
            return undefined;
        }

        const newLead = googlePlaceID
            ? {
                  ...sfWebToLead,
                  googlePlaceID,
                  vestimateAmt,
                  sfUnitId: null,
              }
            : { ...sfWebToLead, vestimateAmt };

        return saveSalesforceWebToLead(newLead).then(setSalesforceWebToLead);
    };
};
